import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, createRef, render } from "preact";
import { getCurrentSchedule } from "../api/Client";
import { Scroll } from "../util/scroll";
import ScheduleConfirmComponent from './modal/ScheduleConfirmComponent';
import CancelPolicyComponent from "./schedule/PreserveCancelPolicyComponent";
import PreserveGroupComponent from "./schedule/PreserveGroupComponent";
import PreserveOptionComponent from "./schedule/PreserveOptionComponent";
import PaymentMethodComponent from "./schedule/PreservePaymentMethodComponent";
import PreservePlanComponent from "./schedule/PreservePlanComponent";
import PreserveTimeComponent from "./schedule/PreserveTimeComponent";
import PreservePlanGroupNumber from "./schedule/PreservePlanGroupNumber";
class SchedulePayComponent extends Component {
    constructor() {
        super();
        this.state = {
            planGroup: [],
            payType: null,
            quantity: 1,
            selectPlanGroup: null,
            selectPlan: null,
            selectSingleOption: null,
            selectMultipleOption: [],
            preserveStart: null,
            preserveEnd: null,
            agreed: false
        };
        this.setPayType = this.setPayType.bind(this);
        this.setPlanGroup = this.setPlanGroup.bind(this);
        this.setPlan = this.setPlan.bind(this);
        this.setPreserveTime = this.setPreserveTime.bind(this);
        this.setAgreed = this.setAgreed.bind(this);
        this.setSingleOption = this.setSingleOption.bind(this);
        this.setMultipleOption = this.setMultipleOption.bind(this);
        this.handleChangeQuantity = this.handleChangeQuantity.bind(this);
        this._modal = createRef();
    }
    render() {
        return (_jsxs("section", Object.assign({ class: "SchedulePayComponent form-container" }, { children: [_jsx(PreserveGroupComponent, { planGroups: this.state.planGroup, onChange: this.setPlanGroup, value: this.state.selectPlanGroup }, void 0),
                _jsx(PaymentMethodComponent, { planGroup: this.state.selectPlanGroup, payType: this.state.payType, setPayType: this.setPayType }, void 0),
                _jsx(PreservePlanGroupNumber, { planGroup: this.state.selectPlanGroup, value: this.state.quantity, onChange: this.handleChangeQuantity }, void 0),
                _jsx(PreservePlanComponent, { plans: this.state.selectPlanGroup?.plans ?? [], onChange: this.setPlan, value: this.state.selectPlan }, void 0),
                _jsx(PreserveTimeComponent, { planGroup: this.state.selectPlanGroup, plan: this.state.selectPlan, setter: this.setPreserveTime }, void 0),
                _jsx(PreserveOptionComponent, { planGroup: this.state.selectPlanGroup, preserveStart: this.state.preserveStart, singleOptionSetter: this.setSingleOption, multipleOptionSetter: this.setMultipleOption }, void 0),
                _jsx(CancelPolicyComponent, { planGroup: this.state.selectPlanGroup, setter: this.setAgreed, preserveStart: this.state.preserveStart }, void 0),
                _jsx(ScheduleConfirmComponent, { selected: this.state, ref: this._modal }, void 0),
                _jsx("footer", { children: _jsx("div", Object.assign({ class: "flex flex__row flex__justify-content-center my2" }, { children: _jsx("a", Object.assign({ className: `button button__danger button__md w50 ${this.enableProseed() ? '' : 'disabled'}`, href: "./orderer.html", onClick: e => this.handleNextClick(e) }, { children: "\u5185\u5BB9\u3092\u78BA\u8A8D\u3059\u308B" }), void 0) }), void 0) }, void 0)] }), void 0));
    }
    componentDidMount() {
        getCurrentSchedule().then(response => {
            this.setState({
                planGroup: response.data.planGroups
            });
        });
    }
    selectablePlanGroup() {
        return this.state.planGroup.filter(p => {
            const payType = this.state.payType ?? '';
            switch (payType) {
                case 'PAY_ADVANCE':
                    return p.payAdvanceFlg;
                case 'PAY_ON_THE_DAY':
                    return p.payOnTheDayFlg;
                default:
                    return false;
            }
        });
    }
    selectablePlans() {
        if (this.state.selectPlanGroup) {
            return this.state.selectPlanGroup.plans;
        }
        return [];
    }
    setPlanGroup(planGroup) {
        const cancelPolicy = planGroup.cancelPolicy ?? '';
        this.setState({
            selectPlanGroup: planGroup,
            selectPlan: null,
            selectMultipleOption: [],
            quantity: planGroup.minPurchaseNumber,
            selectSingleOption: null,
            agreed: cancelPolicy.length === 0
        });
        Scroll.scrollIntoView('#PerservePaymentMethodComponent', 500);
    }
    setPlan(plan) {
        this.setState({ selectPlan: plan });
        Scroll.scrollIntoView('#PreserveTimeComponent', 500);
    }
    setPayType(payType) {
        this.setState({ payType: payType });
        Scroll.scrollIntoView('#PreservePlanComponent', 500);
    }
    setPreserveTime(start, end) {
        this.setState({ preserveStart: start, preserveEnd: end });
    }
    setSingleOption(option) {
        this.setState({
            selectSingleOption: option
        });
    }
    setMultipleOption(options) {
        this.setState({
            selectMultipleOption: options
        });
    }
    setAgreed(agreed) {
        console.debug(`agreed setter => ${agreed}`);
        this.setState({ agreed: agreed });
    }
    enableProseed() {
        return this.state.selectPlanGroup != null &&
            this.state.selectPlan != null &&
            this.state.preserveEnd != null &&
            this.state.preserveStart != null &&
            this.state.agreed === true;
    }
    handleNextClick(e) {
        e.preventDefault();
        const hasNextProceed = this.enableProseed();
        if (hasNextProceed === true) {
            this._modal.current?.openModal();
        }
    }
    handleChangeQuantity(quantity) {
        this.setState({ quantity });
    }
}
window.addEventListener('load', () => {
    const root = document.querySelector('#SchedulePayComponent');
    if (root) {
        render(_jsx(SchedulePayComponent, {}, void 0), root);
    }
});
